import React, { PropTypes } from 'react';

const Header = () => {
  const style = require('./Header.scss');
  const navy_blue = require("./img/navy_blue.png");
  const anim = require("./img/anim.gif");
  const houseBlack = require("./img/houseBlack.png");
  return (
    <div className={style.wrapper}>
      <div className={style.bg} style={{backgroundImage: 'url("'+ navy_blue + '")'}}>
      <div className={style.hbox} style={{backgroundImage: 'url("'+ anim + '"), url("'+ houseBlack + '")'}}>
        <h1 className={style.htxt}>
          Tack Sverige!
        </h1>
        <p className={style.ptxt}>
          SVT Nyheter bad publiken om hjälp med att göra vårt hyrestest och dela med er av era erfarenheter. <span className={style.strongnum}>Vi är överväldigade av responsen. </span>
      <br/>Fler än 53.000 personer från hela landet gjorde vårt test, och av dem valde fler än 6.500 att skriva in sina personliga berättelser och erfarenheter till oss. Tack!
        </p>
        <div className={style.numBox}>
          <div className={style.circle1}>
            <p className={style.ctxt}> Fler än <span className={style.strongnum}> 53.000 </span> svarade </p>
          </div>
          <div className={style.circle2}>
            <p className={style.ctxt}> Över <span className={style.strongnum}> 6.500 </span> skrev in </p>
          </div>
          <div className={style.circle3}>
            <p className={style.ctxt}> Så här <br/> bor  Sverige</p>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Header;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Special/Header/Header.js
 **/